import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  DialogTrigger
} from "@fluentui/react-components";
import React from "react";
import { useIntl } from "react-intl";

export const AppListConfirmDialog: React.FC<
  {
    title: string,
    message: string,
    open: boolean,
    setOpen: (value: boolean) => void,
    onCancel?: () => void,
    action: () => void
  }
> = ({ title, message, open, setOpen, action, onCancel }) => {
  const intl = useIntl();
  const onConfirm = () => {
    action();
    setOpen(false);
  }
  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{title}</DialogTitle>
          <DialogContent>
            <div>{message}</div>
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary" onClick={() => {
                if (onCancel) {
                  onCancel();
                }
                setOpen(false)
              }}>{
                  intl.formatMessage({ defaultMessage: "Cancel" })
                }</Button>
            </DialogTrigger>
            <Button appearance="primary" onClick={() => onConfirm()}>{
              intl.formatMessage({ defaultMessage: "Confirm" })
            }</Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}